module.exports = __webpack_public_path__ + "img/Airbnb-Pomodoro-Sit-Stand2-scaled.63e50439.jpg";